import "../../styles/Footer.css";
const Footer = () => {
  return (
    <div className="Footer py-2">
      <div className="logo">
        <h2 className="text-light m-0 text-center w-100 py-2">Phoenix Labs</h2>
      </div>
      <div className="container h-100 text-white py-3">
        <div className="row h-100">
          <div className="col-6 col-md-3 ">
            <table>
              <th className="fs-5 ">Reach us</th>
              <tr>
                <td className="d-flex gap-2 align-items-center py-1">
                  <i className="fa-solid fa-envelope"></i>
                  <a
                    href="mailto:aeshort@jmediacorp.com"
                    rel="noreferrer"
                    target="_blank"
                  >
                    phoenixlabsglobal@gmail.com
                  </a>
                </td>
                <td className="d-flex gap-2 align-items-center py-1">
                  <i class="fa-solid fa-phone"></i>
                  <a href="tel:1-800-372-7052">1-800-372-7052</a>
                </td>
                <td className="d-flex gap-2 align-items-center py-1">
                  <i class="fa-solid fa-location-dot"></i>
                  <a href="/" style={{ pointerEvents: "none" }}>
                    Dallas, TX 75219, United States
                  </a>
                </td>
              </tr>
            </table>
          </div>
          <div className="col-6 col-md-3 ">
            <table>
              <th className="fs-5">Services</th>
              <tr>
                <td className="d-flex gap-2 align-items-center py-1">
                  <a href="/art">Artificial Intelligence Center</a>
                </td>
                <td className="d-flex gap-2 align-items-center py-1">
                  <a href="https://crypto-technology-center.netlify.app/">
                    Crypto Technology Center
                  </a>
                </td>

                <td className="d-flex gap-2 align-items-center py-1">
                  <a href="/partnership">Partnerships and Collaborations</a>
                </td>
              </tr>
            </table>
          </div>
          <div className="col-6 col-md-3 ">
            <table>
              <th className="fs-5">Company</th>
              <tr>
                <td className="d-flex gap-2 align-items-center py-1">
                  <a href="/aboutus">About</a>
                </td>

                <td className="d-flex gap-2 align-items-center py-1">
                  <a href="/contactus">Contact Us</a>
                </td>
                <td className="d-flex gap-2 align-items-center py-1">
                  <a href="/career">Careers</a>
                </td>
                <td className="d-flex gap-2 align-items-center py-1">
                  <a href="/presskit">Press Kit</a>
                </td>
              </tr>
            </table>
          </div>
          <div className="col-6 col-md-3 ">
            <table>
              <th className="fs-5">Legal</th>
              <tr>
                <td className="d-flex gap-2 align-items-center py-1">
                  <a href="/legalCompliance">Legal and Compliance</a>
                </td>

                <td className="d-flex gap-2 align-items-center py-1">
                  <a href="/research-papers">Research Center</a>
                </td>

                <td className="d-flex gap-2 align-items-center py-1">
                  <a href="/privacyPolicy">Privacy Policy</a>
                </td>
                <td className="d-flex gap-2 align-items-center py-1">
                  <a
                    href="/Phoenix Labs - Terms of Service.docx"
                    download="Phoenix Labs - Terms of Service.docx"
                  >
                    Terms of service
                  </a>
                </td>
                <td className="d-flex gap-2 align-items-center py-1">
                  <a href="/newsupdates">News & Updates</a>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-center gap-5 py-2">
        <a
          href="https://www.facebook.com/profile.php?id=100085708352952"
          rel="noreferrer"
          target="_blank"
        >
          <i className="fa-brands fa-facebook fs-4"></i>
        </a>

        <a
          href="https://twitter.com/PhoenixLab94718"
          rel="noreferrer"
          target="_blank"
        >
          <i className="fa-brands fa-twitter fs-4"></i>
        </a>

        <a
          href="https://www.tiktok.com/@phoenix.labs"
          rel="noreferrer"
          target="_blank"
        >
          <i className="fa-brands fa-tiktok fs-4"></i>
        </a>

        <a
          href="https://www.instagram.com/phoenixlabs1/"
          rel="noreferrer"
          target="_blank"
        >
          <i className="fa-brands fa-instagram fs-4"></i>
        </a>

        <a
          href="https://www.linkedin.com/company/labs-phoenix/"
          rel="noreferrer"
          target="_blank"
        >
          <i className="fa-brands fa-linkedin fs-4"></i>
        </a>
      </div>
      <div>
        <p
          className=" text-white m-0 text-center"
          style={{ fontSize: "0.9rem" }}
        >
          &copy; Phoenix Labs 2023-2024
        </p>
      </div>
    </div>
  );
};

export default Footer;
